(() => {
 const form=document.querySelector('#product-finder');
 if(!form)return;
 const cards=[...document.querySelectorAll('#finder-results .card')];
 const update=()=>{
  const category=form.elements.category.value,budget=Number(form.elements.budget.value);
  let count=0;
  for(const card of cards){
   const matches=(category==='all'?card.dataset.category!=='bundles':card.dataset.category===category)&&Number(card.dataset.price)<=budget;
   card.hidden=!matches;if(matches)count++;
  }
  document.querySelector('#finder-count').textContent=`${count} ${count===1?'product':'producten'} binnen je selectie`;
  document.querySelector('#finder-empty').hidden=count!==0;
 };
 form.addEventListener('submit',event=>{event.preventDefault();update()});
 form.addEventListener('change',update);
 form.addEventListener('reset',()=>setTimeout(update,0));
 update();
})();
